var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"design-modal-button-container",on:{"click":_vm.showModal}},[_c('div',{staticClass:"design-modal-button-button"},[_vm._v("\n        "+_vm._s(_vm.locale("ripe_retail.designs.show_all"))+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }